import { IBasketDto } from "@crunchit/types";
import { defaultBasket } from "./defaults";

export const basketFactory = (basket: Partial<IBasketDto> | null = {}): IBasketDto => {
  return {
    ...defaultBasket,
    ...basket,
  };
};
